import React from 'react';
import { motion } from 'framer-motion';
import { Bell, Search, FileText, ArrowRight, Sparkles } from 'lucide-react';
import { AppShell } from '../components/AppShell';
import { SearchWidget } from '../components/SearchWidget';
export function DashboardPage() {
  return <AppShell data-id="element-636">
      <div className="p-6 lg:p-8 max-w-7xl mx-auto space-y-8" data-id="element-637">
        {/* Welcome Section */}
        <div data-id="element-638">
          <h1 className="text-2xl text-navy-950 mb-1" data-id="element-639">Hola, Dr. Rossi</h1>
          <p className="text-navy-600" data-id="element-640">
            Aquí está el resumen de su inteligencia regulatoria de hoy.
          </p>
        </div>

        {/* Premium Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-641">
          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-card" data-id="element-642">
            <div className="flex items-center gap-3 text-navy-600 mb-4" data-id="element-643">
              <Bell size={18} data-id="element-644" />
              <span className="text-sm font-medium" data-id="element-645">Nuevas Alertas</span>
            </div>
            <div className="flex items-baseline gap-3" data-id="element-646">
              <span className="text-2xl text-navy-950" data-id="element-647">12</span>
              <span className="text-sm text-emerald-500 font-medium bg-emerald-50 px-2 py-0.5 rounded-md" data-id="element-648">
                +3 hoy
              </span>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-card" data-id="element-649">
            <div className="flex items-center gap-3 text-navy-600 mb-4" data-id="element-650">
              <Search size={18} data-id="element-651" />
              <span className="text-sm font-medium" data-id="element-652">Búsquedas Activas</span>
            </div>
            <div className="flex items-baseline gap-3" data-id="element-653">
              <span className="text-2xl text-navy-950" data-id="element-654">8</span>
              <span className="text-sm text-slate-400 font-medium" data-id="element-655">
                monitoreando
              </span>
            </div>
          </div>

          <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-xl border border-navy-700 p-6 shadow-card text-white relative overflow-hidden" data-id="element-656">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-500/20 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-657" />
            <div className="relative z-10" data-id="element-658">
              <div className="flex items-center gap-3 text-slate-300 mb-4" data-id="element-659">
                <Sparkles size={18} className="text-brand-400" data-id="element-660" />
                <span className="text-sm font-medium" data-id="element-661">Análisis Semántico</span>
              </div>
              <div className="flex items-baseline gap-3 mb-2" data-id="element-662">
                <span className="text-2xl text-white" data-id="element-663">4</span>
                <span className="text-sm text-brand-400 font-medium" data-id="element-664">
                  matches por contexto
                </span>
              </div>
              <button className="text-xs text-brand-400 hover:text-brand-300 font-medium flex items-center gap-1 transition-colors" data-id="element-665">
                Ver insights <ArrowRight size={12} data-id="element-666" />
              </button>
            </div>
          </div>
        </div>

        {/* Two Column Layout: Activity + Search Widget */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6" data-id="element-667">
          {/* Activity Feed — 3/5 width */}
          <div className="lg:col-span-3" data-id="element-668">
            <div className="flex items-center justify-between mb-4" data-id="element-669">
              <h2 className="text-lg text-navy-950" data-id="element-670">Actividad Reciente</h2>
              <a href="/inbox" className="text-sm text-brand-500 hover:text-brand-400 font-medium transition-colors" data-id="element-671">
                Ver todo el historial
              </a>
            </div>

            <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden" data-id="element-672">
              {[{
              id: 1,
              type: 'alert',
              title: 'Disposición 1234/2023 - ANMAT',
              keyword: 'Vademécum',
              time: 'Hace 2 horas',
              unread: true
            }, {
              id: 2,
              type: 'semantic',
              title: 'Resolución 456/2023 - SENASA',
              keyword: 'Importación (Contexto: Restricciones)',
              time: 'Hace 5 horas',
              unread: true
            }, {
              id: 3,
              type: 'alert',
              title: 'Circular 89/2023 - Ministerio de Salud',
              keyword: 'Trazabilidad',
              time: 'Ayer',
              unread: false
            }, {
              id: 4,
              type: 'alert',
              title: 'Boletín Oficial - Sección 1',
              keyword: 'Licitación Pública',
              time: 'Ayer',
              unread: false
            }, {
              id: 5,
              type: 'semantic',
              title: 'Disposición 2298/2026 - ANMAT',
              keyword: 'Medicamentos oncológicos (Contexto)',
              time: 'Hace 2 días',
              unread: false
            }].map(item => <div key={item.id} className={`p-4 flex items-start gap-4 border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors cursor-pointer ${item.unread ? 'bg-brand-50/30' : ''}`} data-id="element-673">
                  <div className={`mt-1 w-2 h-2 rounded-full shrink-0 ${item.unread ? 'bg-brand-500' : 'bg-transparent'}`} data-id="element-674" />
                  <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center shrink-0 text-navy-600" data-id="element-675">
                    {item.type === 'semantic' ? <Sparkles size={14} className="text-brand-500" data-id="element-676" /> : <FileText size={14} data-id="element-677" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-678">
                    <div className="flex items-center justify-between gap-4 mb-1" data-id="element-679">
                      <p className={`text-sm truncate ${item.unread ? 'font-medium text-navy-950' : 'text-navy-800'}`} data-id="element-680">
                        {item.title}
                      </p>
                      <span className="text-xs text-slate-400 shrink-0" data-id="element-681">
                        {item.time}
                      </span>
                    </div>
                    <p className="text-xs text-navy-600 truncate" data-id="element-682">
                      Match en búsqueda:{' '}
                      <span className="font-medium" data-id="element-683">{item.keyword}</span>
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Search Widget — 2/5 width */}
          <div className="lg:col-span-2" data-id="element-684">
            <div className="mb-4" data-id="element-685">
              <h2 className="text-lg text-navy-950" data-id="element-686">Búsqueda Rápida</h2>
            </div>
            <SearchWidget mode="compact" data-id="element-687" />
          </div>
        </div>
      </div>
    </AppShell>;
}